import {
	Box,
	Button,
	Card,
	CardActions,
	CardContent,
	Grid,
	Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormType } from '@/api/enum/formType.enum';
import { useEffect, useState } from 'react';
import UserInfoForm from './components/FamilyInfoForm';
import {
	DefaultValues,
	FormProvider,
	SubmitHandler,
	useForm,
} from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FamilyRequest } from '@/api/DTO/family/family.interface';
import AppRadioGroup from '@/common/components/form-inputs/AppRadioGroup';
import {
	ONOFF,
	ONOFF_BOOLEAN,
	PAUSEORMOVEWAITING,
	YESNO,
} from '@/common/constants/common';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useNavigate, useParams } from 'react-router-dom';
import {
	useGetFamilyDetailQuery,
	useUpdateEducationMutation,
	useUpdateRemarksMutation,
	useUpdateServiceDetailsMutation,
} from '@/api/family-management/familyApi';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';
import AppDatePicker from '@/common/components/form-inputs/AppDatePicker';
import AppTextField from '@/common/components/form-inputs/AppTextField';
export default function FamilyEditRemarksPage() {
	const { t } = useTranslation();
	const { familyId } = useParams();
	const navigate = useNavigate();
	const [updateRemarks] = useUpdateRemarksMutation();

	const { data: details } = useGetFamilyDetailQuery(familyId || '', {
		refetchOnMountOrArgChange: true,
	});

	const defaultValues: DefaultValues<any> = {};

	const formSchema = Yup.object().shape({});

	const methods = useForm<any>({
		defaultValues,
		resolver: yupResolver(formSchema),
	});

	useEffect(() => {
		if (details) {
			methods.reset(details.data);
		}
	}, [details]);

	const onSubmit: SubmitHandler<any> = async (data) => {
		const response = await updateRemarks(data);
		if ('data' in response) {
			enqueueSnackbar(t('snackbar.updateFamilySuccess'), {
				variant: 'success',
				anchorOrigin: { horizontal: 'center', vertical: 'top' },
				autoHideDuration: 3000,
				action: (key) => {
					return <CloseIcon onClick={() => closeSnackbar(key)} />;
				},
			});
			handleClose();
		}
	};

	const handleClose = () => {
		navigate(`/family-management/family-management-list/detail/${familyId}`);
	};

	return (
		<>
			<Box sx={{ width: '100%' }}>
				<Box>
					<Typography variant='h4'>
						{t('drawerListItems.editFamilyMember')}
					</Typography>
					<Card sx={{ marginTop: 3 }}>
						<FormProvider {...methods}>
							<form onSubmit={methods.handleSubmit(onSubmit)}>
								<CardContent sx={{ padding: '24px' }}>
									<Typography
										variant='h6'
										sx={{ fontWeight: 'bold' }}
										marginBottom={2}
									>
										{t('family.internalRemarks')}
									</Typography>
									<Grid
										container
										spacing={3}
										marginTop={0}
										marginBottom={3}
										alignItems='center'
									>
										<Grid size={6}>
											<AppTextField
												control={methods.control}
												name='pirRemarks'
												label={t('family.remarksAndPIR')}
											/>
										</Grid>
										<Grid size={6}>
											<AppTextField
												control={methods.control}
												name='applicantRemarks'
												label={t('family.remarks')}
											/>
										</Grid>
									</Grid>
								</CardContent>
								<CardActions sx={{ justifyContent: 'end', padding: '24px' }}>
									<Button onClick={handleClose}>{t('button.cancel')}</Button>
									<Button
										type='submit'
										variant='contained'
										endIcon={<CheckCircleOutlineIcon />}
									>
										{t('button.complete')}
									</Button>
								</CardActions>
							</form>
						</FormProvider>
					</Card>
				</Box>
			</Box>
		</>
	);
}
